export var ImageExtensions = /*#__PURE__*/ function(ImageExtensions) {
    ImageExtensions["PNG"] = "png";
    ImageExtensions["JPG"] = "jpg";
    ImageExtensions["JPEG"] = "jpeg";
    return ImageExtensions;
}({});
